module.exports = __webpack_public_path__ + "img/1-1.376df3f9.png";